export default __webpack_public_path__ + "static/top-9342d00a98086a099db2c0e7851a5d4a.png";